import NavLinkItem from "./NavLinkItem";
import { NAV_ITEMS } from "./navItems";

/**
 * Mobile slide-down nav panel — only rendered when `open` is true.
 */
export default function MobileNavPanel({ onAnchorClick }) {
  return (
    <div
      data-testid="mobile-nav-panel"
      className="lg:hidden border-t border-border/60 bg-background/[0.98] backdrop-blur-md"
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex flex-col gap-1">
        {NAV_ITEMS.map((item) => (
          <NavLinkItem
            key={item.label}
            item={item}
            onAnchorClick={onAnchorClick}
            variant="mobile"
          />
        ))}
      </nav>
    </div>
  );
}
